module.exports = __webpack_public_path__ + "img/8.1ba03cd1.jpg";